<template>
    <div class="interface-browser">
        <!--<v-toolbar-items color="grey darken-1" dark>-->
            <!--<v-btn flat>Menu 1</v-btn>-->
            <!--<v-btn flat>Menu 2</v-btn>-->
            <!--<v-btn flat>Menu 3</v-btn>-->
        <!--</v-toolbar-items>-->

        <v-tabs class="interface-browser__header" slider-color="blue" v-model="openIndex" height="26">
            <v-tab class="interface-browser__tab" v-for="(tab, index) in tabsSystem" :key="index" ripple>
                <span>{{tab.history[tab.historyActive].title}}</span>
                <v-btn v-if="index" class="tab-close" @click.stop="onClose(index)" small flat icon>
                    <v-icon class="tab-icon">close</v-icon>
                </v-btn>
            </v-tab>
        </v-tabs>

        <div v-for="(tab, index) in tabsSystem" :key="index" v-show="openIndex == index" class="tab-content">
            <NavPage :value.sync="tabsSystem[index]" @action="onAction($event)"/>

            <div class="interface-browser__page">
                <item-page @action="onAction($event, tab)" :src="tab.history[tab.historyActive].url"></item-page>
            </div>
        </div>
    </div>
</template>

<script>
    import NavPage from './nav-page'
    import ItemPage from './page.vue'

    export default {
        components: {
            NavPage,
            ItemPage
        },
        props: {
            tabs: Array,
            default: () => [
                // {
                //      url: String,
                //      title: String
                // }
            ]
        },
        data () {
            return {
                openIndex: 0,
                tabsSystem: []
            }
        },
        methods: {
            setActiveLastTab () {
                this.openIndex = (this.tabsSystem.length - 1).toString()
            },
            createTab ({url, title}) {
                this.tabsSystem.push({
                    historyActive: 0,
                    history: [{url, title}]
                })
            },
            onClose (tabIndex) {
                this.tabsSystem.splice(tabIndex, 1)
                if (tabIndex == this.openIndex) {
                    this.setActiveLastTab()
                } else {
                    let index = this.openIndex - 1
                    if (index < 0) {
                        index = 0
                    }
                    this.openIndex = (index).toString()
                }
            },
            onAction (actionData, tab) {
                if (actionData.action === 'open') {
                    this.actionOpen(actionData, tab)
                } else if (actionData.action === 'event') {
                    this.$emit('event', {
                        name: actionData.name,
                        data: actionData.payload,
                        url: tab.history[tab.historyActive].url
                    })
                }
            },
            actionOpen (actionData, tab) {
                let tabData = {
                    title: actionData.title || actionData.url,
                    url: actionData.url
                }

                if (!tab || actionData.target === '_blank') {
                    this.createTab(tabData)
                    this.setActiveLastTab()
                } else {
                    tab.history.push(tabData)
                    tab.historyActive = tab.history.length - 1
                }
            }
        },
        created () {
            this.tabs.forEach(({url, title}) => {
                this.createTab({url, title})
            })
        }
    }
</script>

<style scoped lang="stylus">
    .tab-content {
        height: calc(100% - 26px)
    }

    .interface-browser {
        height 100%
        overflow hidden

        &__header {
            z-index: 1
            position relative
            border-bottom 1px solid #b4b4b4

            /deep/ .tabs__bar {
                background #c8c5c8
            }
        }

        &__tab {
            position relative
            font-size 11px

            /deep/ .tabs__item--active {
                color: #fff
                background-color #878787
                z-index -1
            }

            &::after,
            &::before {
                top -1px
                display block
                content ''
                height 100%
                z-index: 10
                position absolute
                border-top 24px #c8c5c8 solid
            }

            &::after {
                right 0
                border-left 6px transparent solid
            }
            &::before {
                left 0
                border-right 6px transparent solid
            }
        }
        &__page {
            height: calc(100% - 30px)
        }
    }
    .tab-icon {
        font-size 16px
    }
    .tab-close {
        margin-right 0
    }
    /deep/ .tabs__item--active {
        z-index 1!important
    }
    /deep/ .tabs__slider-wrapper {
        z-index 2!important
    }
</style>